import { render, staticRenderFns } from "./content-display.vue?vue&type=template&id=63de5cca&"
import script from "./content-display.vue?vue&type=script&lang=js&"
export * from "./content-display.vue?vue&type=script&lang=js&"
import style0 from "./_content-display.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports